<template>
  <div ref="line" class="line"></div>
</template>

<script>
import * as echarts from 'echarts';

export default {
  name: 'LineCharts',
  props: {
    title: {
      type: String,
      default: ''
    },
    list_x: {
      type: Array,
      default: () => []
    },
    series_name: {
      type: String,
      default: ''
    },
    list_y: {
      type: Array,
      default: () => []
    },
    series_name2: {
      type: String,
      default: ''
    },
    list_y2: {
      type: Array,
      default: () => []
    },
    dataType: {
      type: String,
      default: ''
    }
  },
  data() {
    return {}
  },
  mounted() {
    const myChart = echarts.init(this.$refs.line)
    let dataType = this.dataType;
    let series = [];
    if (this.list_y && this.list_y.length > 0) {
      series.push({
        name: this.series_name,
        type: 'line',
        smooth: true,
        data: this.list_y,
        // 折线的样式
        lineStyle: {
          color: '#409EFF',
          width: 3
        },
        // 区域填充颜色
        areaStyle: {
          color: {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              {
                offset: 0,
                color: 'rgba(64, 158, 255, 0.3)' // 0% 处的颜色
              },
              {
                offset: 1,
                color: 'rgba(64, 158, 255, 0.05)' // 100% 处的颜色
              }
            ],
            global: false // 缺省为 false
          }
        },
        // 数据点样式
        symbol: 'circle',
        symbolSize: 6,
        itemStyle: {
          color: '#409EFF',
          borderColor: '#ffffff',
          borderWidth: 2
        }
      });
    }
    if (this.list_y2 && this.list_y2.length > 0) {
      series.push({
        name: this.series_name2,
        type: 'line',
        smooth: true,
        data: this.list_y2,
        // 折线的样式
        lineStyle: {
          color: '#67C23A',
          width: 3
        },
        // 区域填充颜色
        areaStyle: {
          color: {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              {
                offset: 0,
                color: 'rgba(103, 194, 58, 0.3)' // 0% 处的颜色
              },
              {
                offset: 1,
                color: 'rgba(103, 194, 58, 0.05)' // 100% 处的颜色
              }
            ],
            global: false // 缺省为 false
          }
        },
        // 数据点样式
        symbol: 'circle',
        symbolSize: 6,
        itemStyle: {
          color: '#67C23A',
          borderColor: '#ffffff',
          borderWidth: 2
        }
      });
    }
    myChart.setOption({
      title: {
        subtext: this.title,
        left: 'left',
        top: 10,
        subtextStyle: {
          fontWeight: 600,
          fontSize: 16,
          color: '#303133'
        }
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'cross',
          label: {
            backgroundColor: '#409EFF'
          },
          lineStyle: {
            color: '#409EFF',
            width: 1,
            type: 'dashed'
          }
        },
        backgroundColor: 'rgba(255,255,255,0.95)',
        borderColor: '#409EFF',
        borderWidth: 1,
        borderRadius: 8,
        padding: [12, 16],
        textStyle: {
          color: '#303133',
          fontSize: 13
        },
        formatter: function (params) {
          let str = '<div style="font-weight: 600; margin-bottom: 8px; color: #303133;">' + params[0].name + '</div>';
          params.forEach(item => {
            let value = item.value;
            if (!!dataType && dataType == 'percent') {
              value = parseFloat((value * 100).toFixed(2)) + '%'
            }
            str += '<div style="margin: 4px 0;">' + item.marker + '<span style="margin-left: 6px;">' + item.seriesName + '：</span><span style="font-weight: 600; color: #409EFF;">' + value + '</span></div>';
          })
          return str;
        }
      },
      legend: {
        show: true,
        top: 10,
        right: 20,
        textStyle: {
          color: '#606266',
          fontSize: 12
        },
        itemGap: 20
      },
      xAxis: {
        show: true,
        type: 'category',
        data: this.list_x,
        axisTick: {
          alignWithLabel: true,
          show: false
        },
        axisLabel: { 
          interval: 'auto', 
          rotate: 0, 
          show: true, 
          color: '#909399',
          fontSize: 12
        },
        axisLine: { 
          show: true,
          lineStyle: {
            color: '#E4E7ED'
          }
        }
      },
      yAxis: {
        show: true,
        type: 'value',
        axisLabel: { 
          color: '#909399',
          fontSize: 12
        },
        axisLine: {
          show: false
        },
        splitLine: { 
          lineStyle: { 
            color: '#F0F2F5',
            type: 'dashed'
          } 
        }
      },
      series: series,
      grid: {
        left: '3%',
        right: '4%',
        top: '15%',
        bottom: '8%',
        containLabel: true
      }
    })
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.line {
  width: 100%;
  height: 100%;
  min-height: 300px;
  transition: all 0.3s ease;
  
  &:hover {
    transform: scale(1.01);
  }
}
</style>
